import styled from "styled-components";

import HomeBgFirst from "../../assets/main-earth-background.jpg";
export const Home = styled.div`
  width: 100w;

  .section-home-first {
    height: 100vh;
    width: 100vw;
    background-image: url(${HomeBgFirst});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    .wrap {
      background-color: rgba(0, 0, 0, 0.2);
    }
    .inner {
      height: 100vh;

      img {
        position: absolute;
        top: 50%;
        cursor: pointer;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .home-page-title {
        font-size: 48px;
        text-shadow: 0 0 10px rgba(255, 255, 255, 0.4);
        color: var(--white);
        font-weight: bold;
        position: absolute;
        top: 10%;
        width: 100%;
        text-align: center;
        @media (max-width: 1280px) {
          font-size: 38px;
          top: 20vh;
        }
        @media (max-width: 768px) {
          font-size: 32px;
          top: 20vh;
        }
      }
    }
  }

  .section-home-second {
    img {
      width: 100%;
    }
  }

  &.kor {
    .kor {
      display: block;
    }

    .eng {
      display: none;
    }
  }

  &.eng {
    .kor {
      display: none;
    }

    .eng {
      display: block;
    }
  }
`;
